import axios from 'axios'
import address from '../address'

export default {
  async getUser() {
    return await axios.get('/users/account_info')
  },
  async updateTanakaId(body) {
    return await axios.patch('users/update_tanaka_id', body)
  },
  async updateAccountInfo(body) {
    return await axios.patch('users/update_account_info', body)
  },

  async getAddressFromZipcode(zipcode) {
    const {
      data: { results },
    } = await address.get('search', { params: { zipcode } })

    return results || [{ address3: '', address1: '', address2: '', zipcode }]
  },
}
